import { Route, Routes } from 'react-router-dom';
import Index from './../view/Index';
import City from './../view/City/index';
const initRouter = () => (
  <Routes>
    <Route path="/" element={<Index />} />
    <Route path="/city" element={<City />} />
  </Routes>
);
export default initRouter;
